import FirstTimeGCOffers from './FirstTimeGCOffers'
import FirstTimeSCOffers from './FirstTimeSCOffers'

type Props = {
  loggedIn: boolean
  scEnabled: boolean
}

function Offers(props: Props) {
  if (!props.loggedIn) {
    return <FirstTimeGCOffers />
  }

  if (props.scEnabled) {
    return <FirstTimeSCOffers />
  }

  return <FirstTimeGCOffers />
}

export default Offers
